import React, { useState, useEffect } from 'react';
import { Button, Col, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm, change } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ValidatedSelect from "../../../components/ValidatedSelect";
import { getIndustries, getOccupations } from "../../../utils/helper";

const AccountOwnerEmploymentStatus = ({ nextStep, prevStep, handleSubmit, active, isUsCitizen, processing, secondary, dispatch, investAccount }) => {
    const [industries] = useState(getIndustries());
    const [occupations] = useState(getOccupations());
    const [disableEmploymentType, setEmploymentType] = useState(false);

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (secondary) {
                dispatch(change('AccountOwnerEmploymentStatusForm', 'employment_type', investAccount.secondary_account_owner_employment_type || null));
                dispatch(change('AccountOwnerEmploymentStatusForm', 'job_occupation', investAccount.secondary_account_owner_job_occupation || null));
                dispatch(change('AccountOwnerEmploymentStatusForm', 'industry', investAccount.secondary_account_owner_industry || null));
                if (investAccount.secondary_account_owner_employment_type) {
                    handleChangeEmployment(investAccount.secondary_account_owner_employment_type);
                }
            } else {
                dispatch(change('AccountOwnerEmploymentStatusForm', 'employment_type', investAccount.primary_account_owner_employment_type || null));
                dispatch(change('AccountOwnerEmploymentStatusForm', 'job_occupation', investAccount.primary_account_owner_job_occupation || null));
                dispatch(change('AccountOwnerEmploymentStatusForm', 'industry', investAccount.primary_account_owner_industry || null));
                if (investAccount.primary_account_owner_employment_type) {
                    handleChangeEmployment(investAccount.primary_account_owner_employment_type);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleNext = (formData) => {
        let payload = {};
        if (secondary) {
            payload.secondary_account_owner_employment_type = formData.employment_type;
            payload.secondary_account_owner_job_occupation = formData.job_occupation;
            payload.secondary_account_owner_industry = formData.industry;
        } else {
            payload.primary_account_owner_employment_type = formData.employment_type;
            payload.primary_account_owner_job_occupation = formData.job_occupation;
            payload.primary_account_owner_industry = formData.industry;
        }
        if(formData.employment_type === 'Student' || formData.employment_type === 'Retired' || formData.employment_type === 'Unemployed' || formData.employment_type === 'Homemaker'){
            nextStep(payload, 1);
        } else {
            nextStep(payload);
        }
    };

    const handleChangeEmployment = value => {
        if (value === 'Student' || value === 'Retired' || value === 'Unemployed' || value === 'Homemaker') {
            dispatch(change('AccountOwnerEmploymentStatusForm', 'job_occupation', 'O21 Other'));
            dispatch(change('AccountOwnerEmploymentStatusForm', 'industry', 'O31 Other'));
            setEmploymentType(true);
        } else {
            setEmploymentType(false);
        }
    };

    const availableEmploymentTypes = [
        {
            label: 'Employed',
            value: 'Employed',
        },
        {
            label: 'Self-Employed',
            value: 'Self-Employed',
        },
        {
            label: 'Student',
            value: 'Student',
        },
        {
            label: 'Retired',
            value: 'Retired',
        },
        {
            label: 'Unemployed',
            value: 'Unemployed',
        },
        {
            label: 'Homemaker',
            value: 'Homemaker',
        },
    ];

    const handleBack = () => {
        prevStep(isUsCitizen ? 1 : 0);
    }

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>What is the Employment Status of the {secondary ? 'secondary' : 'primary'} owner?</span>
                </div>
                <div className="account-info-container">
                    <FormGroup row>
                        <Label sm={4}>Employment Type</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedSelect}
                                onChange={handleChangeEmployment}
                                options={availableEmploymentTypes}
                                name="employment_type"
                                placeholder="Select Employment Type" />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Occupation</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedSelect}
                                options={occupations}
                                isSearchable={true}
                                isClearable={true}
                                disabled={disableEmploymentType}
                                name="job_occupation"
                                placeholder="Select Occupation" />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Industry</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedSelect}
                                options={industries}
                                isSearchable={true}
                                isClearable={true}
                                disabled={disableEmploymentType}
                                name="industry"
                                placeholder="Select Industry" />
                        </Col>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.employment_type) {
        errors.employment_type = 'Field is required';
    }
    if (!values.job_occupation) {
        errors.job_occupation = 'Field is required';
    }
    if (!values.industry) {
        errors.industry = 'Field is required';
    }
    return errors;
};

export default reduxForm({
    form: 'AccountOwnerEmploymentStatusForm',
    validate,
})(AccountOwnerEmploymentStatus);
